<template>
  <div>
    <el-form ref="formRef"  label-width="88px">
      <el-form-item label="用户留言：">
        <p>{{content}}</p>
      </el-form-item>
      <el-form-item label="一伴回复：">
        <el-input :rows="4" type="textarea" v-model="preMsg" placeholder="300字以内" style="width:33em;"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { updateSuccessfulCommentReply } from "@/api/url";

export default {
  name: "MsgReplyDialog",
  props: {
    value: Object
  },
  data() {
    return {
      content: this.value.row.content,
      id: this.value.row.id,
      preMsg: this.value.row.replyContent?this.value.row.replyContent:"",
      loading: false,
      // msg:'',
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.preMsg) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '回复不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.id;
      param['replyContent'] = this.preMsg;
      postFormData(updateSuccessfulCommentReply, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
